import axiosPost from "../axiosPost";

/**
 * GateReportePresentismoGet — reporte plan vs eventos (presentismo).
 */
export const gateReportePresentismoGet = async (
    {
        merchantServicioUsuarioId = null,
        usuarioId = null,
        gateZonaId = null,
        gateLugarId = null,
        fechaDesde,
        fechaHasta,
        userId = null,
        page = null,
        pageSize = null,
        debug = 0,
    },
    credentials
) => {
    const body = {
        service: "GateReportePresentismoGet",
        params: {
            merchantId: credentials.merchantId,
            merchantServicioUsuarioId,
            usuarioId,
            gateZonaId,
            gateLugarId,
            fechaDesde,
            fechaHasta,
            userId,
            page,
            pageSize,
            debug,
        },
    };

    return await axiosPost(body, credentials);
};
